import { render, staticRenderFns } from "./member_config.vue?vue&type=template&id=7703421c"
import script from "./member_config.vue?vue&type=script&lang=js"
export * from "./member_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports